import { statusEnum } from "../../../sharedComponents/StatusIndicator";
import classNames from "classnames/bind";
import classes from "./StatusBody.module.scss";

const StatusBody = (rowData: any): React.ReactElement => {
  const key = rowData.active;
  const status: any = key ? statusEnum.Active : statusEnum.Inactive;
  const cx = classNames.bind(classes);
  const emptyFieldValue = "—";

  return rowData.userId ? (
    <div className={cx(classes.status)}>
      <div
        className={cx(classes.statusBadge, {
          isActive: status === "Active",
        })}
      ></div>
      <span>{status}</span>
    </div>
  ) : (
    <>
      <span>{emptyFieldValue}</span>
    </>
  );
};

export { StatusBody };
